
export default function Introduction() {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            こんな<span className="text-blue-900">お悩み</span>ありませんか？
          </h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {[
            {
              icon: 'ri-time-line',
              title: '補助金の情報収集に時間がかかりすぎる',
              description: '最新の補助金情報を追いかけるだけで手一杯。本業に集中できない。'
            },
            {
              icon: 'ri-file-damage-line',
              title: '申請書類の作成が難しい',
              description: '専門用語が多く、何を書けばいいのか分からない。採択率も不安。'
            },
            {
              icon: 'ri-scales-line',
              title: '契約書や法務リスクが心配',
              description: '取引先との契約内容に不安がある。トラブルを未然に防ぎたい。'
            },
            {
              icon: 'ri-team-line',
              title: '複数の専門家に依頼するのが面倒',
              description: '補助金は税理士、法務は行政書士、集客はWeb会社…バラバラで連携が取れない。'
            },
            {
              icon: 'ri-money-dollar-circle-line',
              title: '補助金を活用して集客したい',
              description: '補助金で設備投資したのに、それを営業に活かせていない。'
            },
            {
              icon: 'ri-question-line',
              title: '地域特有の制度が分からない',
              description: '東京都や神奈川県の独自制度があるらしいが、情報が見つからない。'
            }
          ].map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${item.icon} text-white text-3xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                {item.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-900 to-blue-700 rounded-3xl p-12 text-white text-center">
          <h4 className="text-3xl font-bold mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            これらの悩みを<span className="text-yellow-400">まとめて解決</span>します
          </h4>
          <p className="text-xl leading-relaxed max-w-4xl mx-auto">
            TOKAN補助金コンサルタントは、補助金・法務・LP制作を一社で提供することで、<br />
            <strong>時間・コスト・連携の無駄</strong>をすべて削減します。
          </p>
        </div>
      </div>
    </section>
  );
}
